/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_Selection_Too_ManyInputs */

const en_admin_user_list_mail_selection_too_many = /** @type {(inputs: Admin_User_List_Mail_Selection_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More than 500 users selected. Please narrow your selection.`)
};

const de_admin_user_list_mail_selection_too_many = /** @type {(inputs: Admin_User_List_Mail_Selection_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr als 500 Nutzer ausgewählt. Bitte grenzen Sie die Auswahl weiter ein.`)
};

/**
* | output |
* | --- |
* | "More than 500 users selected. Please narrow your selection." |
*
* @param {Admin_User_List_Mail_Selection_Too_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_selection_too_many = /** @type {((inputs?: Admin_User_List_Mail_Selection_Too_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_Selection_Too_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_selection_too_many(inputs)
	return en_admin_user_list_mail_selection_too_many(inputs)
});